import React from 'react';
import { Container } from './styles';

const Error401: React.FC = () => {
  return (
    <Container>
      <h1>401</h1>
      <p>Acesso não autorizado.</p>
    </Container>
  );
};

export default Error401;
